import { doc, writeBatch } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { FaqDataToUpdate } from "../types";

type Data = {
  [faqId: string]: FaqDataToUpdate;
};

export const bulkUpdateFaqsList = async (
  faqGroupId: string,
  data: Data,
): Promise<void> => {
  const batch = writeBatch(db);

  Object.entries(data).forEach(([faqId, faqData], index) => {
    const docRef = doc(db, `faqGroups/${faqGroupId}/faqs/${faqId}`);
    batch.update(docRef, { ...faqData, order: index + 1 });
  });

  await batch.commit();
};
